import { useCallback } from 'react'
import { openStandaloneViewerTab } from '@/standalone-reference-viewer/utils/open-standalone-viewer-tab'
import { ContentViewerActions } from '@/content-viewer/store/slice'
import { useAppDispatch } from '@/store/store-hooks'
import type { AgentV2Reference } from '@/agent-v2/store/schemas'
import type { CaseLawReferenceTab } from '@/citator/schema/case-law-reference-tab'
import type { RiaCitatorSection } from '@/analytics/enums/ria.enums'
import { buildAgentV2ReferenceViewerSession } from '@/agent-v2/references/build-agent-v2-reference-viewer-session'
import { getAgentV2ExternalReferenceUrl } from '@/agent-v2/references/agent-v2-reference-opening'

export function useOpenAgentV2ReferenceViewer() {
  const dispatch = useAppDispatch()

  return useCallback(
    (
      reference: AgentV2Reference | undefined,
      turnId?: string,
      options?: { defaultTab?: CaseLawReferenceTab; defaultOpenSection?: RiaCitatorSection }
    ): boolean => {
      if (!reference) return false
      const externalUrl = getAgentV2ExternalReferenceUrl(reference)
      if (externalUrl) return openStandaloneViewerTab(externalUrl)

      const session = buildAgentV2ReferenceViewerSession(reference, turnId)
      if (!session) return false

      const { defaultTab, defaultOpenSection } = options ?? {}
      dispatch(
        ContentViewerActions.setContentViewerSession({
          session:
            defaultTab || defaultOpenSection
              ? {
                  ...session,
                  presentation: {
                    ...session.presentation,
                    ...(defaultTab ? { defaultTab } : {}),
                    ...(defaultOpenSection ? { defaultOpenSection } : {}),
                  },
                }
              : session,
        })
      )
      return true
    },
    [dispatch]
  )
}
